import Urls from '../urls.js';
import { fetch_status, fetch_json, fetch_error, fetcher } from '../../../../scripts/utils/fetch.js';
import ModalView from '../../../../scripts/utils/modal-view.js';

export default class ProductLeaseAppView extends ModalView {
	constructor({
		el,
		modal_selector,
		product,
		navigation
	}) {
		super({ el, modal_selector, navigation });
		this.template_url = Urls.Templates.app;
		this.product = product;
		this.leasing_terms_data = null;
		this.selected_term = null;
		this.fetch_leasing_terms();
	}

	after_render() {
		this.once_rendered();
		this.initSelectors();
		this.select_term();
	}

	get_context() {
		var settings = window.SiteSettings || {};

		return {
			product: this.product,
			navigation: this.navigation,
			terms: this.get_leasing_terms(),
			types: this.get_leasing_types(),
			phone: settings.COMPANY_PHONE ? settings.COMPANY_PHONE : null
		};
	}

	get_unique(collection, key) {
		return collection.filter((item, index, self) => self.findIndex(t => t.place === item.place && t[key] === item[key]) === index);
	}

	get_leasing_terms() {
		const leasing_terms = this.get_unique(this.leasing_terms_data, 'leasing_term_id');

		return leasing_terms;
	}

	get_leasing_types() {
		const leasing_types = this.get_unique(this.leasing_terms_data, 'leasing_type_id');

		return leasing_types;
	}

	initSelectors() {
		this.removeListeners();
		this.leasing_term_element = this.modal.querySelector('[name="leasing-term"]');
		this.leasing_type_element = this.modal.querySelector('[name="leasing-type"]');
		this.equipment_cost_element = this.modal.querySelector('[name="equipment-cost"]');
		this.monthly_payment_elements = this.modal.querySelectorAll('.js-monthly-payment');
		this.btn_proceed_element = this.modal.querySelector('[name="proceed"]');
		this.addListeners();
	}

	addListeners () {
		if (this.leasing_term_element) {
			this.leasing_term_element.addEventListener('change', this.select_term.bind(this));
		}
		if (this.equipment_cost_element) {
			['change', 'keyup', 'paste'].forEach(evt_name => {
				this.equipment_cost_element.addEventListener(evt_name, this.select_term.bind(this));
			});
		}
		if (this.btn_proceed_element) {
			this.btn_proceed_element.addEventListener('click', this.save_term.bind(this));
		}
	}

	removeListeners () {
		if (this.leasing_term_element) {
			this.leasing_term_element.removeEventListener('change', this.select_term.bind(this));
		}
		if (this.equipment_cost_element) {
			['change', 'keyup', 'paste'].forEach(evt_name => {
				this.equipment_cost_element.removeEventListener(evt_name, this.select_term.bind(this));
			});
		}
		if (this.btn_proceed_element) {
			this.btn_proceed_element.removeEventListener('click', this.save_term.bind(this));
		}
	}

	fetch_leasing_terms() {
		const url = Urls.Api.terms(this.product.id);

		fetcher(url)
			.then(data => {
				this.leasing_terms_data = data;

				this.render();
			});
	}

	select_term() {
		const terms = this.leasing_terms_data.filter(({
			leasing_term_id,
			leasing_type_id
		}) => {
			return leasing_term_id === this.leasing_term_element.value && leasing_type_id === this.leasing_type_element.value;
		});

		this.selected_term = terms.find(term => {
			return this.product.price >= term.amount_from && this.product.price <= term.amount_to;
		});

		if (this.selected_term) {
			const payment = parseFloat(this.selected_term.rate) * this.get_equipment_cost_value();
			const payment_rounded = Math.round(payment * 100) / 100;
			const payment_money = payment_rounded.money();

			this.monthly_payment_elements.forEach(elm => elm.textContent = payment_money);
			this.btn_proceed_element.removeAttribute('disabled');
			this.equipment_cost_element.removeAttribute('disabled');
		} else {
			// show error?
			this.btn_proceed_element.setAttribute('disabled', true);
		}
	}

	get_equipment_cost_value() {
		const val = this.equipment_cost_element.dataset.price;

		return val ? parseFloat(val) : 0;
	}

	save_term() {
		if (this.selected_term) {
			const term = this.get_parsed_values();
			const url = Urls.Api.term;

			this.btn_proceed_element.setAttribute('disabled', true);
			this.btn_proceed_element.classList.add('progress');

			fetch(url, {
				method: 'POST',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(term)
			})
				.then(fetch_status)
				.then(fetch_json)
				.then(() => {
					const add_product_event = new CustomEvent('[add-to-cart]:add-product');

					this.btn_proceed_element.removeAttribute('disabled');
					this.btn_proceed_element.classList.remove('progress');

					document.dispatchEvent(add_product_event);
				});
		}
	}

	get_parsed_values() {
		return {
			...this.selected_term,
			LeaserId: this.selected_term.leaser_id,
			LeaserTermId: this.selected_term.leaser_term_id,
			LeasingTermId: this.selected_term.leasing_term_id,
			LeasingTypeId: this.selected_term.leasing_type_id
		};
	}

}
